import { render } from "./ButtonPanel.vue?vue&type=template&id=7773d110"
import script from "./ButtonPanel.vue?vue&type=script&lang=js"
export * from "./ButtonPanel.vue?vue&type=script&lang=js"

import "./ButtonPanel.vue?vue&type=style&index=0&id=7773d110&lang=scss"
script.render = render

export default script